import { EditorBacklogLevelView } from './EditorBacklogLevelView';

/**
 * Class for managing the level backlog from the editor world map.
 */
export class EditorBacklog extends Phaser.Group {
  /**
   * constructor
   */
  constructor() {
    super(game);
    this.fixedToCamera = true;

    this._overlay = this.add(this._createOverlay());

    this._levelViews = this._createLevelViews();

    this.onLevelSelected = new Phaser.Signal();
    this.onShowPage = new Phaser.Signal();

    this._pageIndex = 0;
    this._makeCloseButton();
    this._addPagesPanel();

    this._showPage(this._pageIndex);
  }

  /**
   * create overlay background
   * @returns {Phaser.Graphics}
   */
  _createOverlay() {
    const overlay = game.add.graphics();
    overlay.beginFill(0x000000, 0.7);
    overlay.drawRect(0, 0, game.width, game.height);
    overlay.inputEnabled = true;
    return overlay;
  }

  /**
   * make the close window button
   */
  _makeCloseButton() {
    const style = { style: 'editor', fontSize: 60 };
    const closeBtn = this.add(new G.Text(game.width - 40, 40, 'X', style, 0.5));
    closeBtn.inputEnabled = true;
    closeBtn.input.useHandCursor = true;
    closeBtn.events.onInputDown.add(this.close, this);
  }

  /**
   * on level selected from backlog
   * @param {string} id
   */
  _selectLevel(id) {
    this.onLevelSelected.dispatch(id);
  }

  /**
   * show a page by index #
   * @param {number} pageIndex
   */
  _showPage(pageIndex) {
    const { levelDataMgr } = G.Helpers;
    const ids = levelDataMgr.getIdsOfBacklogLevels();
    const idsForPage = ids.slice(
      this._levelViews.length * pageIndex,
      this._levelViews.length * (pageIndex + 1),
    );
    this._levelViews.forEach((item, i) => {
      item.init(idsForPage[i]);
    });
    this._pageIndex = pageIndex;
    this.onShowPage.dispatch(pageIndex);
  }

  /**
   * create panel for paging
   */
  _addPagesPanel() {
    const group = this.add(game.make.group());
    group.position.setTo(20, game.height - 50);
    const style = { style: 'editor', fontSize: 40 };

    // page # field
    const pageNumberText = group.add(new G.Text(250, 0, `PAGE ${this._pageIndex + 1}`, style, [0.5, 0]));
    this.onShowPage.add((pageIndex) => {
      pageNumberText.setText(`PAGE ${pageIndex + 1}`);
    });

    // prev page buttton
    const prevBtn = group.add(new G.Text(0, 0, 'PREV', style, 0));
    prevBtn.inputEnabled = true;
    prevBtn.input.useHandCursor = true;
    prevBtn.events.onInputDown.add(() => {
      this._showPage(Math.max(0, this._pageIndex - 1));
    });

    // next page button
    const nextBtn = group.add(new G.Text(400, 0, 'NEXT', style, 0));
    nextBtn.inputEnabled = true;
    nextBtn.input.useHandCursor = true;
    nextBtn.events.onInputDown.add(() => {
      this._showPage(this._pageIndex + 1);
    });
  }

  /**
   * create level view thumbnails
   */
  _createLevelViews() {
    const list = [];
    const margin = 50;
    const itemSize = 200;
    for (let y = margin; y < game.height - (itemSize + margin); y += itemSize) {
      for (let x = margin; x < game.width - (itemSize + margin); x += itemSize) {
        const item = this.add(new EditorBacklogLevelView(x, y));
        item.onClicked.add(this._selectLevel, this);
        list.push(item);
      }
    }
    return list;
  }

  /**
   * close function
   */
  close() {
    if (this.parent) this.parent.removeChild(this);
    this.destroy();
  }
}
